import React from "react";
import { Col } from "react-bootstrap";
import gutter from "src/functions/gutter";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";

function PricesIntroEn() {
  return (
    <>
      <Col xs={{ span: 12, order: 1 }} sm={6} lg={{ span: 4, order: 1 }}>
        <Heading type={`h2`} variant={`primary`} title={`Sale in pieces`} />
        <Paragraph size={`md`} width={`semibold`}>
          Only pay for what you really use
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Do you want to buy premium content, try our platform or practice only
          occasionally? Choose a serie or class that suits you and pay only for
          what you practice. The prices of the content are determined by the
          instructors themselves.
        </Paragraph>
        <br />
      </Col>
      <Col xs={{ span: 12, order: 3 }} sm={6} lg={{ span: 4, order: 2 }}>
        <Heading type={`h2`} variant={`primary`} title={`Subscription`} />
        <Paragraph size={`md`} width={`semibold`}>
          Do you prefer a monthly subscription?
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          We have good news for those of you who like unlimited access to
          content. We will launch a subscription in the near future. This will
          allow you to discover the series and classes of different instructors
          without restrictions.
        </Paragraph>
        <br />
      </Col>
      <Col xs={{ span: 12, order: 5 }} sm={6} lg={{ span: 4, order: 3 }}>
        <Heading type={`h2`} variant={`primary`} title={`Free content`} />
        <Paragraph size={`md`} width={`semibold`}>
          Try sample classes for free!
        </Paragraph>
        <Paragraph
          size={`xn`}
          width={`regular`}
          style={gutter(`margin`, `bottom`, `0`)}
        >
          Do you want to test whether the approach of the selected instructor
          suits you before you buy the offered serie or class? View the
          instructor's profile and find free sample class. They are marked with
          the Sample tag. This will ensure that you have made the right choice.
        </Paragraph>
        <br />
      </Col>
    </>
  );
}

export default PricesIntroEn;
